'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
export const Textarea = (_a) => {
    var { ariaDescribedBy, className, disabled, id, inputMode, maxLength, name, onChange, placeholder, readOnly, required, rows = 1, title, float, value, defaultValue } = _a, other = __rest(_a, ["ariaDescribedBy", "className", "disabled", "id", "inputMode", "maxLength", "name", "onChange", "placeholder", "readOnly", "required", "rows", "title", "float", "value", "defaultValue"]);
    const componentClassName = classnames('sparky-c-textarea', className, {
        'sparky-c-textarea--no-float': float === false,
    });
    const textAreaRef = React.useRef(null);
    React.useEffect(() => {
        textAreaRef &&
            (textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current) &&
            (textAreaRef === null || textAreaRef === void 0 ? void 0 : textAreaRef.current.addEventListener('input', () => {
                if (textAreaRef.current != undefined) {
                    textAreaRef.current.style.height = '0px';
                    const scrollHeight = textAreaRef.current.scrollHeight;
                    textAreaRef.current.style.height = scrollHeight + 'px';
                }
            }));
    }, []);
    return (_jsx("textarea", Object.assign({ ref: textAreaRef, className: componentClassName, id: id, name: name, rows: rows, value: value, defaultValue: defaultValue, placeholder: placeholder, maxLength: maxLength, inputMode: inputMode, disabled: disabled, readOnly: readOnly, onChange: onChange, required: required, title: title, "aria-describedby": ariaDescribedBy }, other)));
};
//# sourceMappingURL=Textarea.js.map